const warehouses = {
  allbranches: {
    siam: {
      campWarehouse: 'Siam',
      isActive: 1,
      sellsukiWarehouse: 'sellsuki'
    },
    empire: {
      campWarehouse: 'Empire',
      isActive: 1,
      sellsukiWarehouse: 'empire'
    },
    khonkaen: {
      campWarehouse: 'Khonkaen',
      isActive: 1,
      sellsukiWarehouse: 'khonkaen'
    },
    megabangna: {
      campWarehouse: 'Megabangna',
      isActive: 1,
      sellsukiWarehouse: 'bangna'
    },
    silom: {
      campWarehouse: 'Silom',
      isActive: 1,
      sellsukiWarehouse: 'silom'
    },
    ngamwongwan: {
      campWarehouse: 'Ngamwongwan',
      isActive: 1,
      sellsukiWarehouse: 'ngamwongwa'
    },
    zen_popup: {
      campWarehouse: 'Zen Popup',
      isActive: 1,
      sellsukiWarehouse: 'zenpopup'
    }
  }
}

const employees = {
  campteam: {
    warehouses: [
      warehouses.allbranches.siam,
      warehouses.allbranches.khonkaen
    ]
  },
  campsiam: {
    warehouses: [
      warehouses.allbranches.siam
    ]
  },
  campngamwongwan: {
    warehouses: [
      warehouses.allbranches.ngamwongwan
    ]
  },
  campbangna: {
    warehouses: [
      warehouses.allbranches.megabangna
    ]
  },
  campkhonkaen: {
    warehouses: [
      warehouses.allbranches.khonkaen
    ]
  },
  campemployee1: {
    warehouses: [
      warehouses.allbranches.empire
    ]
  },
  campemployee2: {
    warehouses: [
      warehouses.allbranches.siam,
      warehouses.allbranches.khonkaen,
      warehouses.allbranches.silom,
      warehouses.allbranches.empire,
      warehouses.allbranches.zen_popup,
      warehouses.allbranches.megabangna
    ]
  }
}

export default employees
